export class TemplateModel {
    key: string;
    label: string;
    content: string;
    additionalContent: string;
}
